/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_phred_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q30 corresponds to an error probability of 0.001, or 99.9% base-call accuracy — one wrong base in a thousand. It is a common quality threshold for sequencing reads.`)
};

const es_phred_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q30 corresponde a una probabilidad de error de 0.001, o 99.9% de precisión de llamada de base — una base incorrecta en mil. Es un umbral de calidad común para las lecturas de secuenciación.`)
};

const de_phred_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q30 entspricht einer Fehlerwahrscheinlichkeit von 0,001 bzw. 99,9% Basenaufruf-Genauigkeit — eine falsche Base pro tausend. Es ist ein gängiger Qualitätsschwellenwert für Sequenzierungs-Reads.`)
};

const nl_phred_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q30 komt overeen met een foutkans van 0,001, oftewel 99,9% nauwkeurigheid bij basecalling — één foute base op duizend. Het is een veelgebruikte kwaliteitsdrempel voor sequencing reads.`)
};

const fr_phred_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q30 correspond à une probabilité d'erreur de 0,001, soit 99,9 % de précision d'appel de base — une base incorrecte sur mille. C'est un seuil de qualité courant pour les lectures de séquençage.`)
};

const it_phred_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q30 corrisponde a una probabilità di errore di 0,001, ossia il 99,9% di accuratezza nel base-calling — una base errata ogni mille. È una soglia di qualità comune per le letture di sequenziamento.`)
};

const pt_br2_phred_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q30 corresponde a uma probabilidade de erro de 0,001, ou 99,9% de precisão na chamada de base — uma base errada a cada mil. É um limiar de qualidade comum para leituras de sequenciamento.`)
};

const pt_phred_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q30 corresponde a uma probabilidade de erro de 0,001, ou 99,9% de precisão na chamada de base — uma base errada em mil. É um limiar de qualidade comum para leituras de sequenciação.`)
};

const ja_phred_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q30はエラー確率0.001、つまり塩基コール精度99.9%に相当します — 1000塩基あたり1つの誤り。シーケンシングリードの一般的な品質基準です。`)
};

const zh_phred_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q30 对应错误概率 0.001，即 99.9% 的碱基判读准确率——一千个碱基中有一个错误。这是测序读段常用的质量阈值。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const phred_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.phred_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("phred_faq_a3", locale)
	if (locale === "en") return en_phred_faq_a3(inputs)
	if (locale === "es") return es_phred_faq_a3(inputs)
	if (locale === "de") return de_phred_faq_a3(inputs)
	if (locale === "nl") return nl_phred_faq_a3(inputs)
	if (locale === "fr") return fr_phred_faq_a3(inputs)
	if (locale === "it") return it_phred_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_phred_faq_a3(inputs)
	if (locale === "pt") return pt_phred_faq_a3(inputs)
	if (locale === "ja") return ja_phred_faq_a3(inputs)
	return zh_phred_faq_a3(inputs)
};